<template>
  <div class="loaderr">
    <div class="sub">
      <span>{{loadErrText}}</span>
      <p class="cursor" @click="loadvideo">{{streamList.length > 0 ? '切换线路' : '点击重试'}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loadErrText: {
      type: String,
      required: true
    },
    streamList: {
      type: Array,
      default: ()=>{
        return []
      }
    }
  },
  methods: {
    loadvideo() {
      if (this.streamList.length > 0) {
        this.$emit("changeStream");
      } else {
        this.$emit("loadvideo");
      }
    }
  }
};
</script>
<style  lang="less" rel="stylesheet/less" scoped>
.loaderr {
  position: fixed;
  z-index: 30;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(34, 34, 34, 1);
  .sub {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  span,
  p {
    display: block;
    color: #ffffff;
  }
  p {
    display: inline-block;
    padding: 10px 15px;
    margin-top: 20px;
    background: #008ACF;
    border-radius: 4px;
  }
  p:hover {
    background: #4cadde;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/bussiness/video/loaderr.vue